<template>
  <div class="home">
    <div>
      <div class="intro-image-container">
        <img
          class="intro-image"
          :src="IntroImage"
          alt="French Impressionism"
          loading="lazy"
        />
      </div>
      <div>
        <div class="intro-text">
        <h2>COMPLIMENTARY AUDIO GUIDE BY TILDA SWINTON</h2>
        <p>
          CHANEL is pleased to provide you with the audio-guide of the <em>Gabrielle Chanel. Fashion Manifesto</em> exhibition on the occasion of its international debut. 
        </p>
        </div>
        <router-link :to="{ name: 'stops', params: {} }" class="button"
          >Next</router-link
        >

      </div>
    </div>
  </div>
</template>

<script>
import IntroImage from "@/assets/images/misc/IntroductionImage.jpg";
export default {
  data() {
    return {
      IntroImage,
    };
  },
  mounted() {
    this.$store.dispatch("togglePlayer", false);
    this.$store.dispatch("togglePlaying", {
      id: 1,
      playing: false
    });
  }
};
</script>

<style lang="scss" scoped>
body {
  height: 100vh;
  background-color: #ffffff;
}
.home {
  margin-top: 40px;
}
.intro-text {
  line-height: 20px;
  font-size: 12px;
  text-align: center;
  max-width: 270px;
  margin: 1em auto;

  h2 {
    margin-bottom: 0.5em;
  }
}
.intro-image-container {
  max-width: 768px;
  margin: 0 auto;
}
.intro-image {
  width: 100%;
  height: auto;
}
.intro-partner-container {
  max-width: 138px;
  margin: 0 auto;
}
.intro-partner {
  width: 100%;
  height: auto;
}

.button {
  margin: 0 auto;
  cursor: pointer;
  background-color: black;
  border-radius: 78px;
  color: white;
  border: 1px solid black;

  height: 33px;
  width: 110px;

  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;

  @include ngv-type($exhibition_subtitle, 14px, 18px);
  color: white;
  font-weight: bold;

  transition: 0.3s ease;
  &:hover {
    background-color: rgba(black, 0.8);
    border-color: rgba(black, 0.8);
  }
}
</style>
